import React from 'react';
import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../../data/mock';

const SEOHead = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  schema
}) => {
  const siteTitle = title 
    ? `${title} | ${companyInfo.name}` 
    : `${companyInfo.name} - ${companyInfo.slogan}`;
  
  const siteDescription = description || 
    `${companyInfo.name} - Venda, locação e manutenção de empilhadeiras em Saltinho/SP. ${companyInfo.experience}. Empilhadeiras diesel, GLP, elétricas, transpaletes e acessórios.`;
  
  const siteKeywords = keywords || 
    'empilhadeiras, empilhadeira diesel, empilhadeira elétrica, locação empilhadeira, aluguel empilhadeira, transpalete, empilhadeira Saltinho, empilhadeira Piracicaba, MAXIMAL, HANGCHA, PALETRANS, manutenção empilhadeira, reforma empilhadeira, pneus empilhadeira';

  const siteImage = image || 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200';
  
  const siteUrl = url || window.location.href;

  // Local Business Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": companyInfo.name,
    "description": siteDescription,
    "image": siteImage,
    "telephone": companyInfo.phone,
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.address.street,
      "addressLocality": companyInfo.address.city,
      "addressRegion": companyInfo.address.state,
      "postalCode": companyInfo.address.cep,
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-22.9064",
      "longitude": "-47.6778"
    },
    "url": siteUrl,
    "sameAs": [
      companyInfo.social.instagram,
      companyInfo.social.facebook,
      companyInfo.social.linkedin
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "priceRange": "$$"
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": companyInfo.name,
    "url": siteUrl,
    "logo": siteImage,
    "foundingDate": "1981",
    "description": siteDescription,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.address.street,
      "addressLocality": companyInfo.address.city,
      "addressRegion": companyInfo.address.state,
      "postalCode": companyInfo.address.cep,
      "addressCountry": "BR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": companyInfo.phone,
      "contactType": "customer service",
      "availableLanguage": "Portuguese"
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />
      <meta name="author" content={companyInfo.name} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Portuguese" />
      <meta name="geo.region" content="BR-SP" />
      <meta name="geo.placename" content="Saltinho" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content={companyInfo.name} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schema || localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
